import { RiskEvaluation } from "@/_models/risk-evaluation.model";
import { DateUtils } from "@/_utility/DateTimeFormat";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { RiskEvaluationStatusLabelPipe } from "@/_pipes/risk-evaluation-status-label.pipe";
import { Component, Input, OnChanges } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { TagModule } from "primeng/tag";

@Component({
    selector: "app-risk-evaluation-task-card",
    standalone: true,
    imports: [
        CommonModule,
        SharedComponentsModule,
        RouterModule,
        RiskEvaluationStatusLabelPipe,
        TagModule,
    ],
    templateUrl: "./risk-evaluation-task-card.component.html",
    styleUrls: [
        "./risk-evaluation-task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class RiskEvaluationTaskCardComponent implements OnChanges {
    @Input() riskEvaluation: RiskEvaluation;
    @Input() isLast: boolean = false;

    title: string = "Untitled Risk Evaluation";
    createdDateLabel: string = "";

    constructor(private dateUtils: DateUtils) {}

    ngOnChanges(): void {
        if (!this.riskEvaluation) {
            return;
        }

        this.title = this.riskEvaluation.title || "Untitled Risk Evaluation";
        this.createdDateLabel = this.riskEvaluation.createdAt
            ? this.dateUtils.formatDateWithConditionalYear(
                  new Date(this.riskEvaluation.createdAt),
              )
            : "";
    }
}
